// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 962 ? "home" : chunkId) + "." + {"570":"35accc8b","962":"af74f72e"}[chunkId] + ".js";
};